import React from "react";
import {T} from "@tolgee/react";
import {Box, Paper, Typography} from "@material-ui/core";

export const SignUpDeprecatedExhibitor = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f5f5f5"
      p={2}
    >
      <Paper
        elevation={3}
        style={{
          padding: "32px",
          maxWidth: "400px",
          textAlign: "center",
          borderRadius: "16px",
        }}
      >
        <Typography variant="h3" gutterBottom>
          <T keyName="global.sign_up.deprecated_title" />
        </Typography>
        <Typography variant="body1">
          <T keyName="global.sign_up.deprecated_message" />
        </Typography>
      </Paper>
    </Box>
  );
};

export default SignUpDeprecatedExhibitor;
